import { render, staticRenderFns } from "./AbilityBrief.vue?vue&type=template&id=48dcccfe&scoped=true&"
import script from "./AbilityBrief.vue?vue&type=script&lang=js&"
export * from "./AbilityBrief.vue?vue&type=script&lang=js&"
import style0 from "./AbilityBrief.vue?vue&type=style&index=0&id=48dcccfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dcccfe",
  null
  
)

export default component.exports